const stopPropagation = (e: Event) => e?.stopPropagation();

export default stopPropagation;
